<template>
  <div class="base-setup" @click="showIconSelect = false">
    <el-form
      ref="baseSetting"
      :rules="rules"
      :model="setup"
      label-position="top"
      label-width="80px"
    >
      <!-- <el-form-item label="表单图标">
        <i :class="setup.logo.icon" :style="'background:' + setup.logo.background"></i>
        <span class="change-icon">
					<span>
						<span>选择背景色</span>
						<el-color-picker v-model="setup.logo.background" show-alpha size="small" :predefine="colors"></el-color-picker>
					</span>
					<span>
						<span>选择图标</span>
						<el-popover placement="bottom-start" width="390" trigger="click">
							<div class="icon-select">
								<i :class="i" v-for="(i, id) in icons" :key="id" @click="setup.logo.icon = i"></i>
							</div>
              <i slot="reference" :class="setup.logo.icon"></i>
            </el-popover>
					</span>
				</span>
      </el-form-item>-->

      <!-- 表 -->
      <el-form-item label="表单名称" prop="formName">
        <el-input v-model="setup.formName" size="medium"></el-input>
      </el-form-item>
      <!-- -->
      <el-form-item label="项目名称" v-if="!setup.deptIds?.length" prop="projectIds" class="project">
        <el-select
          v-model="setup.projectIds"
          clearable
          filterable
          placeholder="请选择项目"
          size="medium"
          @change="projectIdChange"
          multiple
          collapse-tags
        >
          <el-option
            v-for="(item, index) in projectArr"
            :key="item.id"
            :label="item.projectName"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="部门名称" v-if="!setup.projectIds?.length" prop="deptIds" class="deptId">
        <treeselect
          multiple
          v-model="setup.deptIds"
          :options="deptList"
          placeholder="请选择部门"
          id="parentId"
          :normalizer="normalizer"
          @open="handleOpen"
        />
      </el-form-item>

      <el-form-item class="m-form-item" label="菜单名称" prop="menuName">
        <treeselect
          :options="menuList"
          placeholder="请选择菜单"
          :normalizer="normalizer2"
          id="id"
          @select="treeSelect"
          v-model="setup.menuName"
          @open="handleOpen"
          @input="inputSelect"
        />
      </el-form-item>

      <el-form-item label="所在分组" class="group" prop="groupId">
        <el-select
          ref="groupSelect"
          v-model="setup.groupId"
          placeholder="请选择分组"
          filterable
          size="medium"
        >
          <el-option v-for="(op, index) in fromGroup" :key="index" :label="op.name" :value="op.id"></el-option>
        </el-select>
        <el-popover
          class="colorBut"
          placement="bottom-end"
          title="新建表单分组"
          width="300"
          v-model="groupVisible"
        >
          <el-input size="medium" v-model="newGroup" placeholder="请输入新的分组名">
            <el-button
              slot="append"
              size="medium"
              type="primary"
              class="line-button"
              @click="addGroup"
            >提交</el-button>
          </el-input>
          <el-button
            icon="el-icon-plus"
            slot="reference"
            size="medium"
            class="line-button"
            plain
          >新建分组</el-button>
        </el-popover>
      </el-form-item>
      <el-form-item label="表单说明">
        <el-input
          placeholder="请输入表单说明"
          v-model="setup.remark"
          type="textarea"
          show-word-limit
          :autosize="{ minRows: 2, maxRows: 5}"
          maxlength="500"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="消息通知方式" :rules="getRule('请选择消息通知方式')">
        <el-select
          v-model="setup.settings.notify.types"
          value-key="name"
          placeholder="选择消息通知方式"
          style="width: 30%;"
          size="medium"
          clearable
          multiple
          collapse-tags
        >
          <el-option v-for="(wc, index) in notifyTypes" :label="wc.name" :key="index" :value="wc"></el-option>
        </el-select>
        <el-input
          size="medium"
          v-model="setup.settings.notify.title"
          style="width: 68%; float:right;"
          placeholder="消息通知标题"
        ></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="谁可以管理此表单">
        <el-select
          v-model="setup.settings.admin"
          @click.native="selectUser('admin')"
          value-key="name"
          class="select-u"
          placeholder="请选择可以管理此表单的人员"
          size="medium"
          clearable
          multiple
        >
          <el-option
            v-for="(wc, index) in setup.settings.admin"
            :label="wc.name"
            :key="index"
            :value="wc"
          ></el-option>
        </el-select>
      </el-form-item>-->
    </el-form>
    <org-picker title="请选择可以管理此表单的人员" multiple ref="orgPicker" :selected="select" @ok="selected"></org-picker>
  </div>
</template>

<script>
import OrgPicker from '@/components/common/OrgPicker'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {
  getallListGroups,
  addgroup,
  projectList,
  getDepartmentList,
  menuTreeselect,
} from '@/api/design'
import iconfont from '@/assets/iconfont/iconfont.json'

export default {
  name: 'FormBaseSetting',
  components: { OrgPicker, Treeselect },
  data() {
    return {
      groupVisible: false,
      projectArr: [],
      menuList: [],
      deptList: [],
      deptListNOtree: [],
      nowUserSelect: null,
      showIconSelect: false,
      select: [],
      newGroup: '',
      fromGroup: [],
      notifyTypes: [
        { type: 'WX', name: '微信通知' },
        { type: 'APP', name: '应用内通知' },
        { type: 'EMAIL', name: '邮件通知' },
        { type: 'SMS', name: '短信通知' },

        { type: 'DING', name: '钉钉通知' },
      ],
      colors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577',
      ],
      icons: [
        'el-icon-delete-solid',
        'el-icon-s-tools',
        'el-icon-s-goods',
        'el-icon-warning',
        'el-icon-circle-plus',
        'el-icon-camera-solid',
        'el-icon-s-promotion',
        'el-icon-s-cooperation',
        'el-icon-s-platform',
        'el-icon-s-custom',
        'el-icon-s-data',
        'el-icon-s-check',
        'el-icon-s-claim',
      ],
      rules: {
        formName: [{ required: true, message: '请输入', trigger: 'blur' }],
        projectIds: [{ required: true, message: '请选择', trigger: 'blur' }],
        deptIds: [{ required: true, message: '请选择', trigger: 'change' }],
        groupId: [{ required: true, message: '请选择', trigger: 'change' }],
        menuName: [{ required: true, message: '请选择', trigger: 'change' }],
      },
    }
  },
  computed: {
    setup() {
      console.log(this.$store.state.design)
      return this.$store.state.design
    },
    disableddept() {
      return this.setup.projectIds != []
    },
  },
  created() {
    console.log(this.setup, ' this.setup---------------==========')
    this.loadIconfont()
    this.getProjectListAll()
    this.getmenuTreeselectAll()
  },
  watch: {
    'setup.deptIds': 'treeSelectChange',
  },
  mounted() {
    this.getGroups()
    this.getDepartmentList()
  },
  methods: {
    inputSelect(val) {
      console.log(val, '-----------------val11111111111111111')
      this.setup.menuName = val
      this.$refs.baseSetting.validateField('menuName')
    },
    handleOpen() {
      this.$refs.groupSelect.blur()
    },
    getmenuTreeselectAll() {
      menuTreeselect({
        type: 0,
      }).then((response) => {
        this.menuList = response.data.data
      })
    },

    treeSelect(data) {
      // console.log(data, 'data-------')
      // this.setup.menuName = data.label
    },
    handleTree(data, id, parentId, children) {
      let config = {
        id: id || 'id',
        parentId: parentId || 'parentId',
        childrenList: children || 'children',
      }

      var childrenListMap = {}
      var nodeIds = {}
      var tree = []

      for (let d of data) {
        let parentId = d[config.parentId]
        if (childrenListMap[parentId] == null) {
          childrenListMap[parentId] = []
        }
        nodeIds[d[config.id]] = d
        childrenListMap[parentId].push(d)
      }

      for (let d of data) {
        let parentId = d[config.parentId]
        if (nodeIds[parentId] == null) {
          tree.push(d)
        }
      }

      for (let t of tree) {
        adaptToChildrenList(t)
      }

      function adaptToChildrenList(o) {
        if (childrenListMap[o[config.id]] !== null) {
          o[config.childrenList] = childrenListMap[o[config.id]]
        }
        if (o[config.childrenList]) {
          for (let c of o[config.childrenList]) {
            adaptToChildrenList(c)
          }
        }
      }
      return tree
    },
    getDepartmentList() {
      getDepartmentList().then((res) => {
        if (res.data.code === 200) {
          this.deptListNOtree = res.data.rows
          this.deptList = this.handleTree(res.data.rows || [])
          console.log(this.deptList, ' this.deptList----------------------')
        }
      })
    },
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.id,
        label: node.deptName,
        children: node.children,
      }
    },

    normalizer2(node) {
      if (node.children && !node.children.length) {
        delete node.children
      }
      return {
        id: node.label,
        label: node.label,
        children: node.children,
      }
    },
    projectIdChange(val) {
      console.log(val, '---------------------------------项目')
      this.setup.deptNames = []
      ;(this.setup.projectNames = []),
        this.projectArr.forEach((d) => {
          val.forEach((d2) => {
            if (d.id == d2) {
              this.setup.projectNames.push(d.projectName)
            }
          })
        })
      this.$refs.baseSetting.validateField('projectIds')
    },
    treeSelectChange(raw) {
      if (raw) {
        this.setup.deptNames = []
        this.setup.projectNames = []
        this.deptListNOtree?.forEach((d) => {
          raw?.forEach((d2) => {
            if (d.id == d2) {
              this.setup.deptNames.push(d.deptName)
              console.log(this.setup.deptNames, '可有匹配的')
            }
          })
        })
      }

      // this.$refs.baseSetting.validateField('deptName')
    },
    getProjectListAll() {
      projectList().then((response) => {
        this.projectArr = response.data.rows
      })
    },
    // getRule(msg) {
    //   return [{ required: true, message: msg, trigger: 'change' }]
    // },
    loadIconfont() {
      if (iconfont && iconfont.id) {
        iconfont.glyphs.forEach((icon) => {
          this.icons.push(
            `${iconfont.font_family} ${iconfont.css_prefix_text}${icon.font_class}`
          )
        })
      }
    },
    getGroups() {
      getallListGroups()
        .then((rsp) => {
          this.fromGroup = rsp.data.data
          console.log(this.fromGroup, 'fromGroup分组')
        })
        .catch((err) => this.$message.error('获取分组异常'))
    },
    addGroup() {
      if (this.newGroup.trim() !== '') {
        addgroup({ name: this.newGroup.trim() })
          .then((rsp) => {
            if (rsp.data.code == 200) {
              this.groupVisible = !this.groupVisible
              this.$message.success(rsp.data.msg)
              this.getGroups()
            } else {
              this.$message.error(rsp.data.msg)
            }
          })
          .catch((err) => this.$message.error(err.response.data))
      }
    },
    selected(select) {
      this.$set(this.setup.settings, this.nowUserSelect, select)
      //this.setup[this.nowUserSelect] = select
    },
    selectUser(key) {
      this.select = this.setup.settings[key]
      this.nowUserSelect = key
      this.$refs.orgPicker.show()
    },
    validate() {
      console.log('一来就校验了----------------')
      this.$refs.baseSetting.validate()
      let err = []
      if (!this.$isNotEmpty(this.setup.formName)) {
        err.push('表单名称未设置')
      }
      //      deptId: null,
      // projectId: null,
      if (
        !this.$isNotEmpty(this.setup.deptIds) &&
        !this.$isNotEmpty(this.setup.projectIds)
      ) {
        err.push('必须选择一个项目或部门')
      }
      if (!this.$isNotEmpty(this.setup.menuName)) {
        err.push('请选择菜单名称')
      }
      if (!this.$isNotEmpty(this.setup.groupId)) {
        err.push('表单分组未设置')
      }
      if (this.setup.settings.notify.types.length === 0) {
        err.push('审批消息通知方式未设置')
      }
      return err
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-form-item__content {
  line-height: 35px;
}
/deep/ .colorBut {
  .el-button:hover,
  .el-button:focus {
    background: #ffffff;
    border-color: #2f4cdd;
    // color: #2f4c;
    color: #2f4cdd;
  }
}
/deep/ .el-input-group__append {
  padding-left: 0;
}
/deep/ .el-button--text {
  color: #2f4cdd;
}
.line-button {
  background-color: #2f4cdd !important;
  color: #ffffff !important;
  border-color: #2f4cdd !important;
  margin-left: 0 !important;
}
/deep/ .el-select-dropdown {
  display: none;
}

.icon-select {
  display: flex;
  flex-wrap: wrap;
  i {
    cursor: pointer;
    font-size: large;
    padding: 10px;
    max-width: 38px !important;
    &:hover {
      box-shadow: 0 0 10px 2px #c2c2c2;
    }
  }
}

/deep/ .select-u {
  width: 100%;
}

.base-setup {
  overflow: auto;
  margin: 0 auto;
  width: 600px;
  height: calc(100vh - 105px);
  background: #ffffff;
  margin-top: 10px;
  padding: 15px 20px;

  i:first-child {
    position: relative;
    cursor: pointer;
    font-size: xx-large;
    color: #ffffff;
    border-radius: 10px;
    padding: 10px;
  }

  .change-icon {
    margin-left: 20px;

    span {
      font-size: small;
      color: #7a7a7a;
      margin-right: 15px;
    }

    i {
      cursor: pointer;
      color: #7a7a7a;
      font-size: x-large;
    }
  }

  /deep/ .el-form-item__label {
    padding: 0;
    font-weight: bold;
  }

  /deep/ .el-form-item {
    margin-bottom: 5px;
  }
}

/deep/ .group {
  .el-select {
    width: calc(100% - 130px);
  }

  .el-button {
    margin-left: 10px;
    width: 120px;
  }
}
/deep/ .project {
  .el-select {
    width: 100%;
  }
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  background-color: #f8f8f8;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #e8e8e8;
}
</style>
